import React from 'react';
import Link from "gatsby-link";

const TagsWidget = ({edges}) => (
    <section className="widget widget_tag_cloud">
        <div>
            <h3 className="widget-title"><span>Tag Cloud</span></h3>
            <div className="tagcloud">
                {edges.map(({ node }) => (
                    <Link to={`/tag/${node.slug}`} key={node.slug} className="tag-cloud-link">{node.name}</Link>
                ))}
            </div>
        </div>
    </section>
);

export default TagsWidget;


// WEBPACK FOOTER //
// ./src/components/TagsWidget.js